import api from './api';

export function getTermsOfService() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/prospeccion/texto-legal`);
}

export function disaproveTerms(data) {
  return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/creditos/${data.idCredito}/prospeccion/rechazar`, data)
}

export function acceptTermsOfService(data) {
  return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores`, data);
}

export function getJuridicalProcess({ tipoIdentificacion, identificacion, idAsesor, idCredito }) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/prospeccion/procesosjuridicos/tipoIdentificacion/${tipoIdentificacion}/identificacion/${identificacion}/idAsesor/${idAsesor}/idCredito/${idCredito}`);
}

export function notifcateClientWhenRuridicalProcessAreDone(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/prospecting/credits/${data.idCredito}/${data.subCanal}/notify-completion`)
}
